import React from "react"
import styled from "styled-components"

const StyledTooltip = styled.div`
    position: absolute;
    z-index: 1;
    padding: 0.3rem 0.6rem;
    font-size: 0.6rem;
    border-radius: 3px;
    background-color: ${props => props.theme.color.black};
    color: white;
    font-weight: normal;
    left: 0;
    bottom: calc(100% + 0.2rem);
    text-align: center;
    font-family: ${props => props.theme.font.sans};
    display: ${props => props.isShown ? "block" : "none"};
`


export default function Tooltip({handleClick, tip, isShown, ...props}) {
    return (
        <StyledTooltip onClick={handleClick} isShown={isShown}>
            {tip}
        </StyledTooltip>
    )
}
